module.exports = __webpack_public_path__ + "static/media/Cross.8ff7cf8b.svg";